export default class PaginatedObject {
    page = 0;
    pageSize = 0;
    pageCount = 0;
    total = 0;
    items = [];
}
